import React, { Component } from 'react'
import { Input } from '@driftt/tide-core-legacy'
import withNotifications from 'components/shared/notifications'

import './style.styl'

const PERSIST_DEBOUNCE_TIMEOUT = 500

class IntegrationRetryDelay extends Component {
    constructor(props) {
        super(props)

        this.state = {
            delay: 15,
            errorMessage: null
        }
    }

    componentDidMount = async () => {
        const retryDelay = await this.props.getDelay(this.props.integration)

        this.setState({
            delay: retryDelay.retryDelayInMinutes
        })
    }

    onChange = (event) => {
        const delay = event.target.value

        const { valid, errorMessage } = this.validateDelay(delay)

        if (valid && !!errorMessage) {
            this.setState({
                delay: "",
            })
            return
        }

        if (valid) {
            this.setState({
                delay: parseInt(event.target.value),
                errorMessage: null
            }, () => onStateSet())
        } else {
            this.setState({
                errorMessage: errorMessage
            })
        }
        const onStateSet = () => {
            this.debouncedPersist(this.state.delay)
        }
    }


    persist = async (delay) => {
        const {setDelay, integration, notifications} = this.props
        await setDelay(delay, integration)
    
        notifications.success(`${integration} settings are updated!`)
    }

    validateDelay = (delay) => {
        if (delay === "") {
            return { valid: true, errorMessage: true }
        }

        if (delay.charAt(0) == 0 || delay.charAt(0) == '-' || parseInt(delay) < 0 || parseInt(delay) > 1440) {
            return { valid: false, errorMessage: "Valid delays are between 1 and 1440 minutes" }
        }
        return { valid: true, errorMessage: null }
    }

    debouncedPersist = _.debounce(this.persist, PERSIST_DEBOUNCE_TIMEOUT)

    render() {
        const { delay, errorMessage } = this.state
        return (
            <div>
                <div className="integration-delay-container">
                    <Input
                        onChange={this.onChange}
                        type="number"
                        value={delay}
                        placeholder="enter a number..."
                    />
                    <span className="integration-delay-span">minutes</span>
                </div>
                {errorMessage && <span className="integration-retry-delay-error"> {errorMessage} </span>}
            </div>
        )
    }
}
export default withNotifications(IntegrationRetryDelay)


// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/IntegrationRetryDelay/index.js